(() => {
  const catalogElement = document.getElementById('OvenCompareCatalog');
  const drawer = document.getElementById('OvenCompare');
  if (!catalogElement || !drawer) return;

  const catalog = JSON.parse(catalogElement.textContent);
  const products = new Map(catalog.products.map((product) => [product.id, product]));
  const strings = catalog.strings;
  const storageKey = 'glowen:compare:v1';
  const maximum = products.size;
  const panel = drawer.querySelector('#OvenComparePanel');
  const launcher = drawer.querySelector('[data-compare-expand]');
  const items = drawer.querySelector('[data-compare-items]');
  const hint = drawer.querySelector('[data-compare-hint]');
  const status = document.getElementById('OvenCompareStatus');
  const page = document.querySelector('[data-oven-compare-page]');
  const params = new URLSearchParams(window.location.search);
  let opener;
  let expanded = false;

  function normalize(value) {
    if (!Array.isArray(value)) return [];
    return [...new Set(value.map(String))].filter((id) => products.has(id)).slice(0, maximum);
  }

  function readSelection() {
    try {
      return normalize(JSON.parse(localStorage.getItem(storageKey)));
    } catch {
      return [];
    }
  }

  let ids = readSelection();
  let selectedView = Boolean(page && (params.has('ovens') ? params.get('ovens') !== 'all' : ids.length));
  if (page && params.has('ovens') && selectedView) {
    ids = normalize(params.get('ovens').split(','));
    persist();
  }

  function persist() {
    try {
      localStorage.setItem(storageKey, JSON.stringify(ids));
    } catch {
      // Browsing and comparing still work when browser storage is unavailable.
    }
  }

  function phrase(key, values = {}) {
    return Object.entries(values).reduce((text, [name, value]) => text.replaceAll(`[${name}]`, value), strings[key]);
  }

  function syncButtons(root = document) {
    const buttons = [...root.querySelectorAll('[data-compare-product]')];
    if (root.matches?.('[data-compare-product]')) buttons.push(root);
    buttons.forEach((button) => {
      const id = button.dataset.compareProduct;
      const selected = ids.includes(id);
      button.hidden = !products.has(id);
      button.setAttribute('aria-pressed', String(selected));
      const label = button.querySelector('[data-compare-label]');
      const text = selected ? strings.added : strings.add;
      if (label && label.textContent !== text) label.textContent = text;
    });
  }

  function setExpanded(value) {
    expanded = value && ids.length > 0;
    panel.hidden = !expanded;
    launcher.hidden = expanded;
    launcher.setAttribute('aria-expanded', String(expanded));
  }

  function minimize() {
    const focusInside = panel.contains(document.activeElement);
    setExpanded(false);
    if (focusInside) launcher.focus({ preventScroll: true });
  }

  function updatePage() {
    if (page) {
      const url = new URL(window.location.href);
      if (selectedView) url.searchParams.set('ovens', ids.join(','));
      else if (ids.length) url.searchParams.set('ovens', 'all');
      else url.searchParams.delete('ovens');
      window.history.replaceState(window.history.state, '', url);
      const description = page.querySelector('[data-compare-description]');
      description.textContent = selectedView
        ? (ids.length ? phrase('selected', { count: ids.length }) : strings.empty)
        : strings.all;
      page.querySelector('[data-compare-show-all]').hidden = !selectedView;
    }
    document.dispatchEvent(new CustomEvent('glowen:compare-change', { detail: { ids: [...ids], selectedView } }));
  }

  function render() {
    const focusedRemove = document.activeElement?.closest('[data-compare-remove]');
    const focusedId = focusedRemove?.dataset.compareRemove;
    const focusWasInside = drawer.contains(document.activeElement);
    const previousIndex = focusedRemove
      ? [...items.querySelectorAll('[data-compare-remove]')].indexOf(focusedRemove)
      : 0;
    const fragment = document.createDocumentFragment();

    ids.forEach((id) => {
      const product = products.get(id);
      const item = document.createElement('li');
      item.className = 'oven-compare__item';
      const link = document.createElement('a');
      link.href = product.url;
      if (product.image) {
        const image = document.createElement('img');
        image.src = product.image;
        image.alt = '';
        image.width = 64;
        image.height = 64;
        link.append(image);
      }
      const title = document.createElement('span');
      title.textContent = product.title;
      link.append(title);
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'oven-compare__remove';
      remove.dataset.compareRemove = id;
      remove.setAttribute('aria-label', phrase('remove', { product: product.title }));
      remove.textContent = '×';
      item.append(link, remove);
      fragment.append(item);
    });

    items.replaceChildren(fragment);
    drawer.hidden = ids.length === 0;
    drawer.querySelector('[data-compare-count]').textContent = phrase('count', { count: ids.length });
    drawer.querySelector('[data-compare-total]').textContent = `${ids.length} / ${maximum}`;
    drawer.querySelector('[data-compare-go]').disabled = ids.length < 2;
    hint.textContent = ids.length < 2 ? strings.minimum : phrase('ready', { maximum });
    setExpanded(expanded);
    syncButtons();
    updatePage();

    if (!ids.length && focusWasInside) {
      if (opener?.isConnected) opener.focus({ preventScroll: true });
      else document.querySelector('[data-compare-product]:not([hidden])')?.focus({ preventScroll: true });
    } else if (focusedId) {
      const buttons = [...items.querySelectorAll('[data-compare-remove]')];
      const next = buttons.find((button) => button.dataset.compareRemove === focusedId)
        || buttons[Math.min(previousIndex, buttons.length - 1)];
      next?.focus({ preventScroll: true });
    }
  }

  function remove(id) {
    const product = products.get(id);
    ids = ids.filter((selected) => selected !== id);
    persist();
    render();
    status.textContent = phrase('removed', { product: product.title, count: ids.length });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-compare-product]');
    if (button && products.has(button.dataset.compareProduct)) {
      event.preventDefault();
      const id = button.dataset.compareProduct;
      opener = button;
      if (ids.includes(id)) {
        setExpanded(true);
        drawer.querySelector('[data-compare-minimize]').focus({ preventScroll: true });
        return;
      }
      if (ids.length === maximum) {
        setExpanded(true);
        hint.textContent = phrase('limit', { maximum });
        status.textContent = phrase('limit', { maximum });
        return;
      }
      ids.push(id);
      if (page) selectedView = true;
      expanded = true;
      persist();
      render();
      status.textContent = phrase('announcement', { product: products.get(id).title, count: ids.length });
      return;
    }

    const removeButton = event.target.closest('[data-compare-remove]');
    if (removeButton && products.has(removeButton.dataset.compareRemove)) remove(removeButton.dataset.compareRemove);
    if (event.target.closest('[data-compare-expand]')) {
      setExpanded(true);
      drawer.querySelector('[data-compare-minimize]').focus({ preventScroll: true });
    }
    if (event.target.closest('[data-compare-minimize]')) minimize();
    if (event.target.closest('[data-compare-clear]')) {
      ids = [];
      persist();
      render();
      status.textContent = strings.empty;
    }
    if (event.target.closest('[data-compare-go]') && ids.length >= 2) {
      const url = new URL(catalog.url, window.location.origin);
      url.searchParams.set('ovens', ids.join(','));
      window.location.assign(url);
    }
    if (event.target.closest('[data-compare-show-all]')) {
      selectedView = false;
      render();
      page.querySelector('[data-compare-description]').focus({ preventScroll: true });
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && expanded && !event.defaultPrevented) minimize();
  });

  window.addEventListener('storage', (event) => {
    if (event.key !== storageKey && event.key !== null) return;
    ids = readSelection();
    if (page) selectedView = true;
    render();
  });

  window.addEventListener('popstate', () => {
    if (!page) return;
    const query = new URLSearchParams(window.location.search);
    selectedView = query.has('ovens') && query.get('ovens') !== 'all';
    if (selectedView) ids = normalize(query.get('ovens').split(','));
    persist();
    render();
  });

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) syncButtons(node);
    }));
  }).observe(document.body, { childList: true, subtree: true });

  window.GlowenCompare = {
    getState: () => ({ ids: [...ids], selectedView }),
  };
  render();
})();
